import { apiClient } from "./apiClient";

export type RegraLoteRoteirizacao = {
  inicio: string;
  fim: string;
  maxComandas: number;
};

export type PedidoNoLote = {
  pedidoIntegracaoId: number;
  displayId: number;
  orderId: number;
  latitude: number;
  longitude: number;
  prontoDesde: string;
  customerName: string | null;
  enderecoResumo: string | null;
  unidadesProntas: number | null;
  unidadesTotal: number | null;
};

export type LoteSugerido = {
  id: string;
  pedidos: PedidoNoLote[];
  distanciasKm: number[];
  distanciaMaximaEntrePedidosKm: number | null;
  quantidadeComandas: number;
  liberadoParaSaida: boolean;
  aguardarCasamentoAte: string | null;
  segundosRestantesAguardar: number | null;
  motivoAguardando: string | null;
};

export type PedidoSemLocalizacao = {
  pedidoIntegracaoId: number;
  displayId: number;
  orderId: number;
  prontoDesde: string;
  customerName: string | null;
  enderecoResumo: string | null;
  geocodeStatus: string | null;
  motivo: string;
};

export type LotesRoteirizacaoResponse = {
  lojaId: number;
  roteirizacaoAutomaticaAtiva: boolean;
  agora: string;
  capacidade: {
    maxComandas: number;
    foraDaJanela: boolean;
    horarioLabel: string;
    regraAtiva: RegraLoteRoteirizacao | null;
  };
  distanciaMaximaCasamentoKm: number;
  aguardarCasamentoMinutos?: number;
  distanciaModo?: "haversine" | "route_two_wheeler";
  distanciaModoLabel?: string;
  regras: RegraLoteRoteirizacao[];
  lotes: LoteSugerido[];
  semLocalizacao: PedidoSemLocalizacao[];
  totais: {
    prontos: number;
    elegiveis: number;
    semLocalizacao: number;
    lotes: number;
    comandasEmLotes: number;
  };
};

export type DespacharRoteirizacaoPayload = {
  lojaId: number;
  entregadorId: number;
  filaId: number;
  pedidosDisplayIds: number[];
  quantidadeEnderecos?: number;
};

export type DespacharRoteirizacaoResult = {
  entregaId: number;
  lojaId: number;
  entregadorId: number;
  filaId: number;
  pedidosDisplayIds: number[];
  quantidadeEnderecos: number;
  chamadaEmitida: boolean;
  distanciaMaximaEntrePedidosKm: number | null;
};

export type GeocodePendentesResult = {
  lojaId: number;
  processados: number;
  ok: number;
  failed: number;
  missingAddress: number;
  skipped: number;
  googleConfigured: boolean;
  items: unknown[];
};

export type GeocodeEnderecoResult = {
  latitude: number;
  longitude: number;
  formattedAddress: string | null;
  enderecoConsultado: string;
};

export const roteirizacaoService = {
  getLotes: (lojaId: number) =>
    apiClient.get<LotesRoteirizacaoResponse>(
      `/roteirizacao/lotes?lojaId=${lojaId}`
    ),

  despachar: (payload: DespacharRoteirizacaoPayload) =>
    apiClient.post<DespacharRoteirizacaoResult>(
      "/roteirizacao/despachar",
      payload
    ),

  geocodePendentes: (lojaId: number, limit = 50) =>
    apiClient.post<GeocodePendentesResult>(
      `/roteirizacao/geocode-pendentes?lojaId=${lojaId}&limit=${limit}`,
      {}
    ),

  geocodeEndereco: (endereco: string) =>
    apiClient.post<GeocodeEnderecoResult>("/roteirizacao/geocode-endereco", {
      endereco,
    }),
};
